import { HeadingTag } from "components/common/Heading";
import { Heading } from "components/common/Heading";
import {
  MISSED_REPAYMENT_HEADING,
  MISSED_REPAYMENT_SUBHEADING,
  MISSED_REPAYMENT_OPTIONS_1,
  MISSED_REPAYMENT_OPTIONS_1_1,
  MISSED_REPAYMENT_OPTIONS_1_2,
  MISSED_REPAYMENT_OPTIONS_2,
  MISSED_REPAYMENT_OPTIONS_2_1,
  MISSED_REPAYMENT_OPTIONS_2_2,
  MISSED_REPAYMENT_OPTIONS_3,
  MISSED_REPAYMENT_OPTIONS_3_1,
} from "./Assertions.const";

export const MissedRepaymentText = () => {
  return (
    <>
      <br />
      <Heading
        tag={HeadingTag.h2}
        size={2}
        className="zb-heading2 title"
        title={MISSED_REPAYMENT_HEADING}
      />

      <div>{MISSED_REPAYMENT_SUBHEADING}</div>
      <div className="missed-options">{MISSED_REPAYMENT_OPTIONS_1}</div>
      <div className="missed-option">{MISSED_REPAYMENT_OPTIONS_1_1}</div>
      <div className="missed-option">{MISSED_REPAYMENT_OPTIONS_1_2}</div>
      <div className="missed-options">{MISSED_REPAYMENT_OPTIONS_2}</div>
      <div className="missed-option">{MISSED_REPAYMENT_OPTIONS_2_1}</div>
      <div className="missed-option">{MISSED_REPAYMENT_OPTIONS_2_2}</div>
      <div className="missed-options">{MISSED_REPAYMENT_OPTIONS_3}</div>
      <div className="missed-option">{MISSED_REPAYMENT_OPTIONS_3_1}</div>
    </>
  );
};
